import { supabase } from '../lib/supabase';
import type { ProvisionDriverResult } from './useProvisionDriver';

export type DriverCredentialResult = ProvisionDriverResult & {
  email_sent?: boolean;
  email_reason?: string | null;
};

export function useDriverAdmin() {
  async function resetDriverPassword(driverId: string, sendEmail = true) {
    const { data, error } = await supabase.functions.invoke('reset-driver-password', {
      body: { driver_id: driverId, send_email: sendEmail },
    });

    if (error) {
      return { data: null, error: error.message };
    }

    const payload = data as DriverCredentialResult & { error?: string };
    if (payload?.error) {
      return { data: null, error: payload.error };
    }

    return { data: payload as DriverCredentialResult, error: null };
  }

  return { resetDriverPassword };
}
